module.exports = function() {
  return new Worker(__webpack_public_path__ + "559dffadeed1bd852029.worker.js");
};